import React from 'react';
import { WORDMARK } from '../../data/registration';
const PORTAL_LINKS = ['How the portal works', 'Your privacy', 'Community guidelines', 'Accessibility', 'Contact the portal team'];
export interface PrototypeLink {
  label: string;
  onSelect: () => void;
  active?: boolean;
}
interface SiteFooterProps {
  /** Prototype-only shortcuts to states that are normally reached by email. */
  prototypeLinks?: PrototypeLink[];
}
export function SiteFooter({
  prototypeLinks
}: SiteFooterProps) {
  return <footer className="w-full border-t border-rule bg-card" data-id="element-235" data-mp="1qmgvpchpl30o">
      <div className="mx-auto w-full max-w-5xl px-4 py-10 sm:px-6" data-id="element-236" data-mp="1cnqyzxysx5cu">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between" data-id="element-237" data-mp="1cnhaketen699">
          <div className="flex flex-col" data-id="element-238" data-mp="1go13f66y3npl">
            <span className="text-heading font-semibold tracking-tight text-ink" data-id="element-239" data-mp="1gr6rqj7r2lk9">
              We Are Stepping Stone
            </span>
            <span className="text-small text-ink-muted" data-id="element-240" data-mp="5afffoctns5n">Hosted by {WORDMARK}</span>
          </div>

          <nav aria-label="Portal" className="flex flex-wrap gap-x-6 gap-y-1 md:flex-col md:items-end" data-id="element-241" data-mp="1xup5fgr78f9x">
            {PORTAL_LINKS.map(link => <a key={link} href="#privacy" className="inline-flex min-h-tap items-center rounded-control text-small text-ink underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-242" data-mp="1syi9mgsiok5p">
                {link}
              </a>)}
          </nav>
        </div>

        {prototypeLinks?.length ? <div className="mt-8 flex flex-col gap-2 rounded-field border border-dashed border-rule p-4" data-id="element-243" data-mp="2qkfmnyo4nxa9">
            <span className="text-eyebrow-caption font-semibold uppercase text-ink-muted" data-id="element-244" data-mp="2lm4b9ji6pepx">
              Prototype only — states normally reached by email
            </span>
            <nav aria-label="Prototype states" className="flex flex-wrap gap-2" data-id="element-245" data-mp="2um9hhqbn672i">
              {prototypeLinks.map(link => <button key={link.label} type="button" onClick={link.onSelect} aria-current={link.active ? 'page' : undefined} className={`inline-flex min-h-tap items-center rounded-pill border px-4 text-small transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${link.active ? 'border-primary bg-primary-soft font-medium text-primary-text' : 'border-rule text-ink hover:bg-canvas'}`} data-id="element-246" data-mp="1s9morgnxea0i">
                  {link.label}
                </button>)}
            </nav>
          </div> : null}

        <div className="mt-8 flex flex-col gap-1 border-t border-rule pt-6 text-small text-ink-muted sm:flex-row sm:justify-between" data-id="element-247" data-mp="qj9aiatncdn2">
          <span data-id="element-248" data-mp="ulcn52s1xo9x">© 2026 Portal</span>
          <span data-id="element-249" data-mp="ume8q16p1t5w">Profiles are never indexed by search engines.</span>
        </div>
      </div>
    </footer>;
}